// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__O0i8U","colMin":"styles_colMin__3FeBk","colCheckbox":"styles_colCheckbox__3mrAd"};